/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/icon/custom-elements';

import { defineCustomElement as defineOsdsIcon } from '@ovhcloud/ods-stencil/components/icon/custom-elements/osds-icon.js';

export const OsdsIcon = /*@__PURE__*/createReactComponent<JSX.OsdsIcon, HTMLOsdsIconElement>('osds-icon', undefined, undefined, defineOsdsIcon);
